import { render, staticRenderFns } from "./oaKpiPeople.vue?vue&type=template&id=24e280b1&scoped=true&"
import script from "./oaKpiPeople.vue?vue&type=script&lang=js&"
export * from "./oaKpiPeople.vue?vue&type=script&lang=js&"
import style0 from "./oaKpiPeople.vue?vue&type=style&index=0&id=24e280b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e280b1",
  null
  
)

export default component.exports